// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-code-import-not-available{font-family:\"Montserrat\";text-transform:uppercase;color:#909090;display:block;padding:2rem}\n", ""]);
// Exports
module.exports = exports;
